export const accountParams = ['bankAccountNumber', 'sortCode', 'iban'] as const;
